import { Injectable } from "@nestjs/common";
import { AssetRequistionRepository } from "./repository/asset-requisition.repository";
import { AssetRequistionAdapter } from "./asset-requistion.adapter";
import { AssetRequestDto } from "./dto/asset-requisition.dto";
import { AssetsDropDown, CommonResponse } from "@gtpl/shared-models/masters";
import { AssetRequistion } from "./entity/asset-requisition.entity";
import { Repository, getManager } from "typeorm";
import appSettings from "apps/services/config";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { Assets } from "../open-assets/open-assets-entity";
import { InjectRepository } from "@nestjs/typeorm";
import moment from "moment";

@Injectable()
export class AssetRequestService {
    constructor(
        private assetRequestRepo: AssetRequistionRepository,
        private assetRequestAdapter: AssetRequistionAdapter,
        @InjectRepository(Assets)
        private assetsRepository: Repository<Assets>,
    ) { }

    async createAssetRequest(requestDto: AssetRequestDto): Promise<CommonResponse> {
        const slNo = await this.assetRequestRepo.count()
        const requestnum = "REQ" + "/" + requestDto.fromPlant + "/" + "23-24" + "/"+"00"+Number(Number(slNo) + 1)
        requestDto.requestCode = requestnum;
        requestDto.status = AssetStatusEnum.INPROGRESS;
        const convertedAssetRequestEntity: AssetRequistion = this.assetRequestAdapter.convertDtoToAssetRequestEntity(requestDto);
        const savedAssetRequestEntity: AssetRequistion = await this.assetRequestRepo.save(convertedAssetRequestEntity);
        const savedAssetRequestDto: AssetRequestDto = this.assetRequestAdapter.convertEntityToDto(savedAssetRequestEntity);
        if (savedAssetRequestDto) {
            // const statusSave = await this.assetsRepository.update({ assetId: requestDto.assetName }, { status: AssetStatusEnum.INPROGRESS})
            const response = new CommonResponse(true, 11100, 'Asset Request Created Successfully. ', savedAssetRequestDto);
            return response;
        } else {
            const response = new CommonResponse(false, 11011, 'something went wrong. ', savedAssetRequestDto);
            return response;
        }
    }

    async getRequestedAssetsData(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT asas.request_id,l.location_name,asas.request_code,asas.request_time,asas.raised_by,asas.asset_category,asas.reason,asas.status,isc.item_sub_category_id,isc.item_sub_category,dep.dept_id,dep.dept_name,emp.employee_id,emp.employee_name
        FROM `+ appSettings.assets_db + `.asset_requistion asas
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = asas.asset_category
        LEFT JOIN `+ appSettings.masters_db + ` .employee_details emp ON emp.employee_id = asas.raised_by
        LEFT JOIN `+ appSettings.masters_db + ` .departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.assets_db + `.assets a ON asas.asset_name = a.assets_name
	 LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping alm ON a.asset_id = alm.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = alm.location_id
        WHERE asas.status = '${AssetStatusEnum.INPROGRESS}'`
        // if (req.assetCode) {
        //     getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        // }
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        }
        // if (req.location) {
        //     getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        // }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and asas.raised_by = ' + req.employeeId + ''
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_id = ' + req.department + ''
        }
        getEntities = getEntities + ' ORDER BY asas.request_time ASC '
        const assetData = await manager.query(getEntities)
        return new CommonResponse(true, 11100, 'Requested Assets Data Retrieved Successfully', assetData)
    }

    async getRequestCompletedAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT  asas.request_id,asas.request_code,asas.asset_name,aas.asset_id,aas.asset_category,isc.item_sub_category , it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,it.item_name,asas.request_time,asas.reason,asas.raised_by,aas.asset_mode FROM `+ appSettings.assets_db + `.asset_requistion asas 
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON asas.asset_name = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.raised_by
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE asas.status = '${AssetStatusEnum.COMPLETED}'`
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and asas.raised_by = ' + req.employeeId + ''
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_id = ' + req.department + ''
        }
        getEntities = getEntities + ' ORDER BY asas.request_time ASC '
        const assetData = await manager.query(getEntities)
        return new CommonResponse(true, 11100, 'Requeste Completed Assets Data Retrieved Successfully', assetData)
    }

    async getAssetCodeDropDownforAssetRequest(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT  asas.request_id,asas.asset_name,aas.asset_id,it.item_name AS assets_name,aas.assets_code,aas.plant
         FROM `+ appSettings.assets_db + `.asset_requistion asas 
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON asas.asset_name = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.asset_id >0 `
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ' ORDER BY it.item_name ASC '
        const assetData = await manager.query(getEntities)
        return new CommonResponse(true, 11100, 'Data Retrieved Successfully', assetData)
    }

    async getAssetCategoryDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_category,isc.item_sub_category_id,isc.item_sub_category,aas.plant,aas.status
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE aas.status = 'INSTOCK' `
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ' '
        }
        getEntities = getEntities + ' GROUP BY isc.item_sub_category ASC'
        const assetData = await manager.query(getEntities)
        return new CommonResponse(true, 11100, 'Data Retrieved Successfully', assetData)

    }
}